module.exports = __webpack_public_path__ + "img/bg_avatar_male_63.a500c988.png";